import { ResponseCatalog, RequestParams } from 'Models'
import { FieldNames } from 'Src/constants/FieldNames'
import { ORDER_DIRECTION } from 'Src/constants/Global'
import { ActUnpaidModel, ActUnpaidCounterModel } from 'Pages/acts'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Src/types/utilTypes'

type ActUnpaidState = {
	data: ResponseCatalog<ActUnpaidModel>
	requestParams: RequestParams
	counter: ActUnpaidCounterModel
}

const actUnpaidInitialState: ActUnpaidState = {
	data: new ResponseCatalog<ActUnpaidModel>(),
	requestParams: new RequestParams(1, 30, null, {
		order_by: FieldNames.NAME,
		order_direction: ORDER_DIRECTION.DESC,
	}),
	counter: {
		on_partner_signing_single: 0,
		on_partner_signing_several: 0,
		amount_more_5k: 0,
	},
}

export namespace actUnpaidNS {
	export type getUnpaidActs = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setUnpaidActs = PayloadAction<ResponseCatalog<ActUnpaidModel>>
	export type setUnpaidActsCounter = PayloadAction<ActUnpaidCounterModel>
	export type clearUnpaidActs = PayloadAction
	export type setUnpaidActsRequestParams = PayloadAction<RequestParams>
	export type getUnpaidActsCounter = PayloadAction
}

export const actUnpaidSlice = createSlice({
	name: 'actUnpaid',
	initialState: actUnpaidInitialState,
	reducers: {
		getUnpaidActs: (state, action: actUnpaidNS.getUnpaidActs) => {},
		setUnpaidActs: (state, action: actUnpaidNS.setUnpaidActs) => {
			state.data = action.payload
		},
		setUnpaidActsCounter: (state, action: actUnpaidNS.setUnpaidActsCounter) => {
			state.counter = action.payload
		},
		clearUnpaidActs: (state, action: actUnpaidNS.clearUnpaidActs) => {
			state.data = new ResponseCatalog<ActUnpaidModel>()
			state.requestParams = Object.assign(new RequestParams(), {
				order_by: state.requestParams.order_by,
				order_direction: state.requestParams.order_direction,
			})
		},
		setUnpaidActsRequestParams: (state, action: actUnpaidNS.setUnpaidActsRequestParams) => {
			state.requestParams = action.payload
		},
		getUnpaidActsCounter: (state, action: actUnpaidNS.getUnpaidActsCounter) => {},
	},
})
